/** 20 survival phrases: Arabic (MSA, understood everywhere), transliteration, it/en/fr. Audio via on-device speech synthesis (works offline when an Arabic voice is installed). */
export const PHRASES = [
  { ar: "السلام عليكم", tr: "as-salāmu ʿalaykum", it: "Buongiorno / Salve (pace su di voi)", en: "Hello (peace be upon you)", fr: "Bonjour (que la paix soit sur vous)" },
  { ar: "شكراً جزيلاً", tr: "shukran jazīlan", it: "Grazie mille", en: "Thank you very much", fr: "Merci beaucoup" },
  { ar: "من فضلك", tr: "min faḍlik", it: "Per favore", en: "Please", fr: "S'il vous plaît" },
  { ar: "نعم / لا", tr: "naʿam / lā", it: "Sì / No", en: "Yes / No", fr: "Oui / Non" },
  { ar: "لا أفهم", tr: "lā afham", it: "Non capisco", en: "I don't understand", fr: "Je ne comprends pas" },
  { ar: "هل تتكلم الإنجليزية؟", tr: "hal tatakallam al-inglīziyya?", it: "Parla inglese?", en: "Do you speak English?", fr: "Parlez-vous anglais ?" },
  { ar: "كم السعر؟", tr: "kam as-siʿr?", it: "Quanto costa?", en: "How much is it?", fr: "Combien ça coûte ?" },
  { ar: "غالٍ جداً", tr: "ghālin jiddan", it: "È troppo caro", en: "Too expensive", fr: "C'est trop cher" },
  { ar: "أين الحمام؟", tr: "ayna al-ḥammām?", it: "Dov'è il bagno?", en: "Where is the toilet?", fr: "Où sont les toilettes ?" },
  { ar: "أريد الذهاب إلى…", tr: "urīdu adh-dhahāb ilā…", it: "Vorrei andare a…", en: "I want to go to…", fr: "Je voudrais aller à…" },
  { ar: "توقف هنا من فضلك", tr: "tawaqqaf hunā min faḍlik", it: "Si fermi qui, per favore", en: "Stop here, please", fr: "Arrêtez-vous ici, s'il vous plaît" },
  { ar: "ماء من فضلك", tr: "māʾ min faḍlik", it: "Acqua, per favore", en: "Water, please", fr: "De l'eau, s'il vous plaît" },
  { ar: "أنا نباتي", tr: "anā nabātī", it: "Sono vegetariano/a", en: "I am vegetarian", fr: "Je suis végétarien(ne)" },
  { ar: "بدون سكر", tr: "bidūn sukkar", it: "Senza zucchero", en: "Without sugar", fr: "Sans sucre" },
  { ar: "الحساب من فضلك", tr: "al-ḥisāb min faḍlik", it: "Il conto, per favore", en: "The bill, please", fr: "L'addition, s'il vous plaît" },
  { ar: "لذيذ!", tr: "ladhīdh!", it: "Delizioso!", en: "Delicious!", fr: "Délicieux !" },
  { ar: "ساعدوني!", tr: "sāʿidūnī!", it: "Aiuto!", en: "Help!", fr: "Au secours !" },
  { ar: "أحتاج إلى طبيب", tr: "aḥtāju ilā ṭabīb", it: "Ho bisogno di un medico", en: "I need a doctor", fr: "J'ai besoin d'un médecin" },
  { ar: "أين الصيدلية؟", tr: "ayna aṣ-ṣaydaliyya?", it: "Dov'è la farmacia?", en: "Where is the pharmacy?", fr: "Où est la pharmacie ?" },
  { ar: "مع السلامة", tr: "maʿa as-salāma", it: "Arrivederci", en: "Goodbye", fr: "Au revoir" },
];

let voices = [];
const synth = typeof window !== "undefined" ? window.speechSynthesis : null;
if (synth) { voices = synth.getVoices(); synth.onvoiceschanged = () => { voices = synth.getVoices(); }; }

export const hasArabicVoice = () => voices.some((v) => v.lang.toLowerCase().startsWith("ar"));

export function speakArabic(text) {
  if (!synth) return false;
  synth.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = "ar-SA"; u.rate = 0.85;
  const v = voices.find((x) => x.lang.toLowerCase().startsWith("ar"));
  if (v) u.voice = v;
  setTimeout(() => { synth.resume(); synth.speak(u); }, 40);
  return true;
}
